/* tslint:disable */
/* eslint-disable */
/**
 * Haltian IoT API-spec
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Coordinate object
 * @export
 * @interface Coordinates
 */
export interface Coordinates {
    /**
     * Latitude number
     * @type {number}
     * @memberof Coordinates
     */
    latitude: number;
    /**
     * Longitude number
     * @type {number}
     * @memberof Coordinates
     */
    longitude: number;
}

export function CoordinatesFromJSON(json: any): Coordinates {
    return CoordinatesFromJSONTyped(json, false);
}

export function CoordinatesFromJSONTyped(json: any, ignoreDiscriminator: boolean): Coordinates {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'latitude': json['latitude'],
        'longitude': json['longitude'],
    };
}

export function CoordinatesToJSON(value?: Coordinates | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'latitude': value.latitude,
        'longitude': value.longitude,
    };
}


